export default "__VITE_ASSET__BZCBVYes__"